import DownloadPlatformButton from 'components/download-page/DownloadPlatformButton'
import DownloadSeparator from 'components/download-page/DownloadSeparator'
import ExternalLink from 'components/UI/ExternalLink'
import { graphql, useStaticQuery } from 'gatsby'
import GetOnFDroid from 'images/get-it-on-fdroid.png'
import GetOnGooglePlay from 'images/get-on-google-play.png'
import { ReactElement } from 'react'
import { Flex } from 'theme-ui'
import getEnglishStrings from 'utils/getEnglishStrings'
import { platforms } from 'utils/platformList'

export default function AndroidDownloadOptions(): ReactElement {
  const translations = useStaticQuery<Queries.AndroidDownloadOptionsQuery>(graphql`
    query AndroidDownloadOptions {
      directus {
        general_translations {
          strings {
            languages_code {
              code
            }
            download
            or
          }
        }
      }
    }
  `)
  const generalTranslationStrings = getEnglishStrings(
    translations.directus.general_translations?.strings,
  )

  return (
    <Flex sx={{ flexDirection: 'column' }}>
      <Flex
        sx={{
          flexWrap: 'wrap',
          a: { width: 'auto' },
          justifyContent: ['center', 'center', 'flex-start'],
        }}
      >
        <ExternalLink href="/install/mobile/android">
          <img src={GetOnGooglePlay} alt="" sx={{ width: '24.8rem', height: '100%' }} />
        </ExternalLink>
        <ExternalLink href="https://f-droid.org/en/packages/com.windscribe.vpn/">
          <img src={GetOnFDroid} alt="" sx={{ width: '24.8rem', height: '100%' }} />
        </ExternalLink>
      </Flex>
      <Flex sx={{ flexDirection: 'column', gap: '2.4rem', maxWidth: ['100%', '100%', '26.8rem'] }}>
        <DownloadSeparator or={generalTranslationStrings?.or} />
        <DownloadPlatformButton
          platformIcon={platforms['Android'].icon}
          downloadText={generalTranslationStrings?.download ?? ''}
          downloadUrl="/install/mobile/android-direct-phone"
          platformType="desktop"
        />
      </Flex>
    </Flex>
  )
}
